import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CLAIM_TYPES, STEP_PATHS } from '../consts';
import { MEDICAL_FLOW, NON_MEDICAL_FLOW } from '../flows';

const useNextAndPrevUrl = (claimType, currentPath) => {
  const { idCheckNeeded } = useSelector((state) => state.nomadInsurance.claims);

  const flow = useMemo(() => {
    const claimTypeFlow =
      claimType === CLAIM_TYPES.MEDICAL ? MEDICAL_FLOW : NON_MEDICAL_FLOW;
    if (idCheckNeeded) return claimTypeFlow;
    return claimTypeFlow.filter((step) => step.path !== STEP_PATHS.ID_VERIFICATION);
  }, [claimType, idCheckNeeded]);

  const currentStepIndex = flow.findIndex((x) => x.path === currentPath);

  const nextUrl = useMemo(() => {
    const nextStepIndex = currentStepIndex + 1;
    if (nextStepIndex >= flow.length) {
      return `/nomad-insurance/claim/${claimType}/${STEP_PATHS.CONFIRMATION}`;
    }
    return `/nomad-insurance/claim/${claimType}/${flow?.[nextStepIndex]?.path}`;
  }, [currentStepIndex, flow, claimType]);

  const prevUrl = useMemo(() => {
    const nextStepIndex = currentStepIndex - 1;
    if (nextStepIndex < 0) {
      return '/nomad-insurance/claim';
    }
    return `/nomad-insurance/claim/${claimType}/${flow?.[nextStepIndex]?.path}`;
  }, [currentStepIndex, flow, claimType]);

  return { nextUrl, prevUrl };
};

export default useNextAndPrevUrl;
